import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {UserDataService} from '../user-data.service';
import {CustomValidators} from './custom-validators';
import {SelectFieldsTable} from '../../../shared/select-fields.table';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    providers: [SelectFieldsTable, SelectLocationTable]
})
export class SignupComponent implements OnInit {

    constructor(private signupService: UserDataService,
                private formBuilder: FormBuilder,
                private selectFields: SelectFieldsTable,
                private locationSelect: SelectLocationTable,
                private router: Router,
                private translate: TranslateService,
                private route: ActivatedRoute) {
        this.frmSignup = this.createSignupForm();
        // Location - Country & City
        this.select = [];
    }

    formResponse: boolean;
    formSent: boolean;

    // Registration Form
    frmSignup: FormGroup;
    registerInfo: object;
    accountTitle = ['client', 'candidate'];
    accountTipe: string;

    // Server Response After Send
    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    emailExistError: boolean;
    userEmail = '';

    // Location - Country & City
    location = this.locationSelect.Countries;

    select: string[];
    cities: Array<any> = [];
    selectedCountry: string;

    titleOption: string;

    ngOnInit() {

    }

    titleSelect(title:string){

        if(title === 'client'){
            //@ts-ignore
            document.getElementById('firstName').placeholder = this.translate.instant('LOGIN.FIRST_NAME') + ' ' + this.translate.instant('LOGIN.CONTACT_DETAILS')
            //@ts-ignore
            document.getElementById('lastName').placeholder = this.translate.instant('LOGIN.LAST_NAME') + ' ' + this.translate.instant('LOGIN.CONTACT_DETAILS')
        }
        if(title === 'candidate'){
            //@ts-ignore
            document.getElementById('firstName').placeholder = this.translate.instant('LOGIN.FIRST_NAME')
            //@ts-ignore
            document.getElementById('lastName').placeholder = this.translate.instant('LOGIN.LAST_NAME')
        }
        
    }

    

    createSignupForm(): FormGroup {
        this.route.url.subscribe(urlSegments => {
            this.titleOption = 'client';
            console.log('Current Route Path:', urlSegments.map(segment => segment.path).join('/'));
            if(urlSegments.map(segment => segment.path).join('/') === 'inregistrare-candidat'){
                this.titleOption = 'candidate';
            }
          });
          return this.formBuilder.group(
            {
                title: [
                    this.titleOption,
                    Validators.required
                ],
                firstName: [
                    null,
                    Validators.compose([Validators.pattern('[a-zăîșțâA-ZĂÎȘȚÂ\\s\'-]*'), Validators.required])
                ],
                lastName: [
                    null,
                    Validators.compose([Validators.pattern('[a-zăîșțâA-ZĂÎȘȚÂ\\s\'-]*'), Validators.required])
                ],
                email: [
                    null,
                    Validators.compose([Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/), Validators.required])
                ],
                password: [
                    null,
                    Validators.compose([
                        Validators.required,
                        // check whether the entered password has a number
                        CustomValidators.patternValidator(/\d/, {
                            hasNumber: true
                        }),
                        // check whether the entered password has upper case letter
                        CustomValidators.patternValidator(/[A-Z]/, {
                            hasCapitalCase: true
                        }),
                        // check whether the entered password has a lower case letter
                        CustomValidators.patternValidator(/[a-z]/, {
                            hasSmallCase: true
                        }),
                        // check whether the entered password has a special character
                        CustomValidators.patternValidator(
                            /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                            {
                                hasSpecialCharacters: true
                            }
                        ),
                        Validators.minLength(7)
                    ])
                ],
                confirmPassword: [null, Validators.compose([Validators.required])],
                country: [null, Validators.required],
                city: [null, Validators.required],
                address: [null],

            },
            {
                // check whether our password and confirm password match
                validator: CustomValidators.passwordMatchValidator
            }
        );
    }

    submit() {
        this.formSent = false;
        // If the all inputs are valid do this
        if (this.frmSignup.valid) {
            // All the inputs you send
            this.registerInfo = {
                email: this.frmSignup.value.email,
                password: this.frmSignup.value.password,
                firstName: this.frmSignup.value.firstName,
                lastName: this.frmSignup.value.lastName,
                city: this.frmSignup.value.city,
                country: this.frmSignup.value.country,
                address: this.frmSignup.value.address,
                title: this.frmSignup.value.title
            }
            // Request To API
            this.signupService.signUpUser(this.registerInfo).subscribe(resData => {
                this.formResponse = true;
                this.formSent = true;
                setTimeout(() => {
                    this.router.navigate(['/autentificare'])
                }, 5000);

                this.userEmail = this.frmSignup.value.email;
            }, error => {
                if (error.error.reason === 'emailExists') {
                    this.emailExistError = true;
                }
                this.formResponse = false;
                this.formSent = true;
            });
        } else {
            // Trigger all the invalid inputs error
            Object.keys(this.frmSignup.controls).forEach(field => {
                const control = this.frmSignup.get(field);
                control.markAsTouched({onlySelf: true});
            });
            this.formResponse = false;
            this.formSent = true;
        }
    }

    citiesReload(event) {
        this.selectedCountry = event.target.value;
        this.cities = this.location.find((cntry: any) => cntry.name === event.target.value).cities;
    }
}
